"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.width = exports.radius = void 0;
var radius = exports.radius = {
  s: '2px',
  m: '4px',
  l: '6px'
};
var width = exports.width = {
  xs: '1px',
  s: '2px',
  m: '4px',
  l: '6px',
  xl: '8px'
};